import React from 'react';
import Logo from '../images/Logo.jsx';

const GuestLayout = ({ children, title }) => {
    return (
        <div className='min-h-screen flex flex-col justify-center items-center bg-guest bg-center bg-cover'>
            <div className='p-5 max-w-3xl w-full'>
                <header className='flex items-center mb-40'>
                    <Logo className='w-60 fill-current text-theme1-white' />
                </header>
                <main>
                    <div className='flex text-theme1-white font-bold text-3.5xl mb-10'>{title}</div>
                    {children}
                </main>
            </div>
        </div>
    );
};

export default GuestLayout;
